export const fmtTL = (v) => {
  if (v == null || Number.isNaN(Number(v))) return "0,00 TL";
  return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v)) + " TL";
};

export const fmtNum = (v, digits = 2) => {
  if (v == null || Number.isNaN(Number(v))) return "0";
  return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: digits }).format(Number(v));
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const parts = String(iso).split("T")[0].split("-");
  if (parts.length !== 3) return iso;
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const fmtDateTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return fmtDate(iso);
  return `${d.toLocaleDateString("tr-TR")} - ${d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}`;
};

const ROLE_LABELS = { admin: "Yönetici", data_entry: "Veri Girişi / Proje", proje_koordinatoru: "Proje Koordinatörü", sube_yetkilisi: "Şube Yetkilisi", gm_yetkili: "GM Yetkilisi", taseron: "Taşeron", muhasebe: "Muhasebe", ik: "İK", finans: "Finans", proje: "Veri Girişi / Proje", satinalma: "Satınalma", gmy: "GMY", idari: "İdari İşler", depo: "Depo", kk_kullanici: "Kredi Kartı Kullanıcısı", patron: "Patron" };

export const fmtCreator = (by, at, labels = {}) => {
  if (!by) return "—";
  const u = labels[by];
  const who = (u && (u.name || ROLE_LABELS[u.role])) || by;
  const when = fmtDateTime(at);
  return when ? `${who} - ${when}` : who;
};

export const currentMonthRange = () => {
  const n = new Date();
  const y = n.getFullYear();
  const mm = String(n.getMonth() + 1).padStart(2, "0");
  const last = String(new Date(y, n.getMonth() + 1, 0).getDate()).padStart(2, "0");
  return { from: `${y}-${mm}-01`, to: `${y}-${mm}-${last}`, month: `${y}-${mm}` };
};
